import React from 'react';

const Icon = ({ size = '35', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 35 35" fill="none" {...other}>
            <path
                d="M8.75 8.954c0-.113.091-.204.204-.204h17.092c.113 0 .204.091.204.204V17.5a8.75 8.75 0 1 1-17.5 0V8.954Z"
                stroke="white"
                strokeWidth="2.188"
            />

            <path d="M14.583 8.75V2.917m5.834 5.833V2.917" stroke="white" strokeWidth="2.188" strokeLinecap="round" strokeLinejoin="round" />

            <path d="M16.042 19.688h2.916" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

            <path d="M17.5 26.25v3.646c0 1.208.98 2.187 2.188 2.187h8.02" stroke="white" strokeWidth="2.188" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default React.memo(Icon);
